// EmailJS public browser configuration (not a private API key).
export const emailConfig = {
  publicKey: 'ANekIEJvDpJgwBCxo',
  serviceId: 'service_euaosgh',
  templateId: 'template_m25z9hb',
};
